module.exports = __webpack_public_path__ + "static/media/2.8c31cd07.png";